import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
// import images
import logodark from "../../../assets/images/darklogo.png"
import logolight from "../../../assets/images/whitelogo.png"

const PackageCancel = () => {
  useEffect(() => {
    // Redirect after 3 seconds
    const timer = setTimeout(() => {
      // Redirect to customer orders page (safe location, not using browser back)
      window.location.href = '/corders';
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  //meta title
  document.title = "Payment Cancelled | BizServe";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container className="mt-5 pt-sm-5">
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="50"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="50"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bx-x-circle h1 mb-0 text-danger"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h1 className="text-danger">Payment Cancelled</h1>
                        <p className="text-muted">You have cancelled the payment.</p>
                        <p className="text-muted">Redirecting you back in 3 seconds...</p>
                        <div className="mt-4">
                          <button 
                            style={{ 
                              backgroundColor: '#405189', 
                              color: '#fff', 
                              border: 'none', 
                              padding: '10px 20px', 
                              borderRadius: '5px', 
                              cursor: 'pointer', 
                              marginTop: '20px' 
                            }} 
                            onClick={() => (window.location.href = '/corders')}
                          >
                            Go to Orders
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} BizServe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by BizServe LLC
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PackageCancel

